export default __webpack_public_path__ + "static/media/quickstart-step-9.2d091024.jpg";